import { IRC_COLORS, IRC_FORMATTING } from '#/constants';

export function getIRCColor(colorCode: number): string {
    return IRC_COLORS[colorCode] || '#ffffff';
}

export function parseIRCFormatting(text: string): string {
    if (!text) return text;
    
    let result = '';
    let bold = false;
    let italic = false;
    let underline = false;
    let color = false;
    let reverse = false;
    
    for (let i = 0; i < text.length; i++) {
        const char = text[i];
        const charCode = text.charCodeAt(i);
        
        switch (charCode) {
            case IRC_FORMATTING.BOLD.charCodeAt(0):
                if (bold) {
                    result += '</strong>';
                    bold = false;
                } else {
                    result += '<strong>';
                    bold = true;
                }
                break;
            case IRC_FORMATTING.UNDERLINE.charCodeAt(0):
                if (underline) {
                    result += '</u>';
                    underline = false;
                } else {
                    result += '<u>';
                    underline = true;
                }
                break;
            case IRC_FORMATTING.ITALIC.charCodeAt(0):
                if (italic) {
                    result += '</em>';
                    italic = false;
                } else {
                    result += '<em>';
                    italic = true;
                }
                break;
            // TODO: Reverse.
            /*case IRC_FORMATTING.REVERSE.charCodeAt(0):
                *   break;
            */
            case IRC_FORMATTING.RESET.charCodeAt(0):
                if (bold) {
                    result += '</strong>';
                    bold = false;
                }
                if (underline) {
                    result += '</u>';
                    underline = false;
                }
                if (italic) {
                    result += '</em>';
                    italic = false;
                }
                if (color) {
                    result += '</span>';
                    color = false;
                }
                reverse = false;
                break;
            case IRC_FORMATTING.COLOR.charCodeAt(0):
                const colorMatch = text.substring(i + 1).match(/^(\d{1,2})(?:,(\d{1,2}))?/);
                if (colorMatch) {
                    if (color) result += '</span>';
                    const fgColor = getIRCColor(parseInt(colorMatch[1]));
                    result += `<span style="color: ${fgColor}">`;
                    color = true;
                    i += colorMatch[0].length;
                }
                break;
            default:
                result += char;
                break;
        }
    }

    if (bold) result += '</strong>';
    if (underline) result += '</u>';
    if (italic) result += '</em>';
    if (color) result += '</span>';
    
    return result;
}

export function getClassFromModes(modes: string[]): string {
    if (modes.includes('q')) {
        return 'owner';
    } else if (modes.includes('a')) {
        return 'admin';
    } else if (modes.includes('o')) {
        return 'op';
    } else if (modes.includes('h')) {
        return 'halfop';
    } else if (modes.includes('v')) {
        return 'voice';
    }
    return '';
}

export function escapeHtml(text: string): string {
    const map: { [key: string]: string } = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
    };
    return text.replace(/[&<>"']/g, (m) => map[m]);
}

export function linkify(text: string): string {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.replace(urlRegex, (url) => `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`);
}

export function processMessage(text: string): { text: string, urls: string[] } {
    const urls: string[] = [];
    const placeholderText = text.replace(/(https?:\/\/[^\s]+)/g, (match) => {
        urls.push(match);
        return `__URL_PLACEHOLDER_${urls.length - 1}__`;
    });
    const escapedText = escapeHtml(placeholderText);
    return { text: escapedText, urls };
}